module.exports = __webpack_public_path__ + "img/policia_estatal_up_selected.308fd510.svg";